module.exports = require('./lib/static/prefixAll')



/*****************
 ** WEBPACK FOOTER
 ** ../~/aphrodite/~/inline-style-prefixer/static.js
 ** module id = 1337
 ** module chunks = 0
 **/